import { omitKeysForLogging as xfinityOmitKeys } from 'flows/tvi/utils/buy/config/xfinity/form-store';
import { omitKeysForLogging as attOmitKeys } from 'flows/tvi/utils/buy/config/att/form-store';
import { omitKeysForLogging as coxOmitKeys } from 'flows/tvi/utils/buy/config/cox/form-store';
import { ContactInformation } from '../utils/buy/config/common/types';

// These are fields that we might store in local storage
// but wouldn’t track on events.
const extraSensitiveFields = ['dob'];

export const SensitiveFields = Array.from(
  new Set([
    ...xfinityOmitKeys,
    ...attOmitKeys,
    ...coxOmitKeys,
    ...extraSensitiveFields,
  ])
);

export enum BuyPages {
  Modems = 'modems',
  Payment = 'payment-method',
  Option = 'payment-option',
  Info = 'payment-info',
  Review = 'review',
  Dob = 'dob',
  AsyncCreditCheck = 'async-credit-check',
  Submission = 'confirmation',
  Error = 'error',
  CurrentAddressLongevity = 'current-address-longevity',
  Identity = 'identity',
  SecureAccount = 'secure-account',
  ScheduleInstallation = 'schedule-installation',
  ShippingAddress = 'shipping-address',
  ScheduleConnection = 'schedule-connection',
  OnePage = 'finalize',
  TermsConditions = 'terms-conditions',
}

export enum GuestBuyAnalyticsEvents {
  Error = 'async_buy_flow_order_error',
  MODEMS = 'async_buy_flow_internet_service_modems',
  DOB = 'async_buy_flow_account-creation',
  ASYNC_CREDIT_CHECK = 'async_buy_flow_credit_check',
  PAYMENT_OPTION = 'async_buy_flow_payment-option',
  PAYMENT_INFO = 'async_buy_flow_credit_card_payment',
  PAYMENT_METHOD = 'async_buy_flow_payment_method',
  SUBMISSION = 'async_buy_flow_confirmation',
  REVIEW = 'async_buy_flow_order_review',
  MODAL_MODEMS = 'async_buy_flow_modal_modems',
  MODAL_STREAMING_DEVICE = 'async_buy_flow_modal_streaming_device',
  MODAL_AUTOPAY = 'async_buy_flow_modal_autopay',
  MODAL_DEPOSIT = 'async_buy_flow_modal_deposit',
  MODAL_FULL_PLAN = 'async_buy_flow_modal_full-plan',
  MODAL_COX_CLICKTOCANCEL = 'async_buy_flow_modal_cox-clicktocancel',
  MODAL_EARLY_TERMINATION = 'async_buy_flow_modal_early-termination',
  MODAL_INSTALL_DATE = 'async_buy_flow_modal_install_date',
  RESERVATION_FAIL = 'async_buy_flow_reservation-fail',
  CURRENT_ADDRESS_LONGEVITY = 'async_buy_flow_current-address-longevity',
  IDENTITY = 'async_buy_flow_identity',
  SECURE_ACCOUNT = 'async_buy_flow_secure-account',
  SCHEDULE_INSTALLATION = 'async_buy_flow_schedule-installation',
  SHIPPING_ADDRESS = 'async_buy_flow_shipping-address',
  SCHEDULE_CONNECTION = 'async_buy_flow_schedule-connection',
  SERVICES = 'async_buy_flow_services',
  INTERNET_SPEED_RANGE = 'async_buy_flow_internet-speed-range',
  INTERNET_PLAN = 'async_buy_flow_internet-plan',
  TV_PROVIDER = 'async_buy_flow_tv-provider',
  INTERNET_EQUIPMENT = 'async_buy_flow_internet-equipment',
  TV_CHANNELS = 'async_buy_flow_tv-channels',
  ADD_TV = 'async_buy_flow_add-tv',
  EDIT_OFFER = 'async_buy_flow_edit_offer',
  FINALIZE = 'async_buy_flow_onepage',
  TERMS_CONDITIONS = 'async_buy_flow_terms_conditions',
  PAYMENT_VALIDATION = 'async_buy_flow_payment_validation',
  CUSTOMER_INFO = 'async_buy_flow_customer_info',
  ORDER = 'async_buy_flow_order',
}

export enum BuyAnalyticsEvents {
  Error = 'buy_flow_error',
  MODEMS = 'buy_flow_internet_service_modems',
  DOB = 'buy_flow_account-creation',
  ASYNC_CREDIT_CHECK = 'buy_flow_async-credit-check',
  PAYMENT_OPTION = 'buy_flow_payment-option',
  PAYMENT_INFO = 'buy_flow_credit_card_payment',
  PAYMENT_METHOD = 'buy_flow_credit_card_payment_method',
  SUBMISSION = 'buy_flow_confirmation',
  REVIEW = 'buy_flow_order_review',
  MODAL_MODEMS = 'buy_flow_modal_modems',
  MODAL_STREAMING_DEVICE = 'buy_flow_modal_streaming_device',
  MODAL_AUTOPAY = 'buy_flow_modal_autopay',
  MODAL_DEPOSIT = 'buy_flow_modal_deposit',
  MODAL_FULL_PLAN = 'buy_flow_modal_full-plan',
  MODAL_COX_CLICKTOCANCEL = 'buy_flow_modal_cox-clicktocancel',
  MODAL_EARLY_TERMINATION = 'buy_flow_modal_early-termination',
  MODAL_INSTALL_DATE = 'buy_flow_modal_install_date',
  MODAL_INSTALLATION_TYPE = 'buy_flow_modal_installation_type',
  RESERVATION_FAIL = 'buy_flow_reservation-fail',
  CURRENT_ADDRESS_LONGEVITY = 'buy_flow_current-address-longevity',
  IDENTITY = 'buy_flow_identity',
  SECURE_ACCOUNT = 'buy_flow_secure-account',
  SCHEDULE_INSTALLATION = 'buy_flow_schedule-installation',
  SHIPPING_ADDRESS = 'buy_flow_shipping-address',
  SCHEDULE_CONNECTION = 'buy_flow_schedule-connection',
  SERVICES = 'buy_flow_services',
  INTERNET_SPEED_RANGE = 'buy_flow_internet-speed-range',
  INTERNET_PLAN = 'buy_flow_internet-plan',
  TV_PROVIDER = 'buy_flow_tv-provider',
  INTERNET_EQUIPMENT = 'buy_flow_internet-equipment',
  TV_CHANNELS = 'buy_flow_tv-channels',
  ADD_TV = 'buy_flow_add-tv',
  EDIT_OFFER = 'buyflow_edit_offer',
  FINALIZE = 'buy_flow_onepage',
  TERMS_CONDITIONS = 'buy_flow_terms_conditions',
  PAYMENT_VALIDATION = 'buy_flow_payment_validation',
}

export const XFinityContactInformation: ContactInformation = {
  submissionContactNumber: '866-853-4518',
  buyFlowContactNumber: '844-341-4838',
  completedSubmissionContactNumber: '800-934-6489',
};

export const ProfessionalInstallationFee = 99;

export const ATTContactInformation: ContactInformation = {
  submissionContactNumber: '877-782-3558',
  buyFlowContactNumber: '844-808-8418',
  completedSubmissionContactNumber: '1-866-861-6075',
};

export const CoxContactInformation: ContactInformation = {
  submissionContactNumber: '877-782-3558',
  buyFlowContactNumber: '844-808-8418',
  // the following should be updated with correct number
  completedSubmissionContactNumber: '800-234-3993',
};

export const SpectrumContactInformation: ContactInformation = {
  submissionContactNumber: '877-782-3558',
  buyFlowContactNumber: '844-808-8418',
  completedSubmissionContactNumber: '833-898-1543',
};

export const StarlinkContactInformation: ContactInformation = {
  submissionContactNumber: '888-626-0260', // TODO: Add real Starlink TFN
  buyFlowContactNumber: '888-626-0260', // TODO: Add real Starlink TFN
  completedSubmissionContactNumber: '888-626-0260', // TODO: Add real Starlink TFN
};
